import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import {
  civil,
  electrical,
  engineeringBanner,
  environmentalAndGeotechnicalServices,
  geospital,
  industrialWaterSupply,
  mechanical,
  oilGasPetroleum,
  trafficDesign,
  transmissionEngineering,
  wastewaterSolutions,
} from 'images/expertise';
import DetailPage from 'containers/expertise/DetailPage';

const Engineering: NextPage = () => {
  return (
    <>
      <Header
        title="Engineering"
        description="We offer a full range of engineering solutions including but not limited to Mechanical & Electrical systems, process systems, utilities, and infrastructure. In conjunction with our trusted partners, we are ready to carry out an complete overhaul in terms of design services - architectural, civil and structural engineering."
        image={engineeringBanner}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: trafficDesign,
            title: 'Traffic Design',
            id: 'trafficDesign',
            hasListItems: true,
            description:
              'Traffic-engineering consultancy including a full range of professional services in transportation planning and traffic engineering design and implementation.',
            listItems: [
              { text: 'Common and Site-Specific Short-term Traffic Management Plans for Permits' },
              { text: 'Single & Dual Lane Closure, Shoulder & Road Closure' },
              { text: 'Detour Route, Two-Way Traffic Pattern' },
              { text: 'Sign Placement & Flagging' },
              { text: 'Lane Shift & Special Events' },
            ],
          },
          {
            bgImage: civil,
            id: 'civil',
            title: 'Civil',
            hasListItems: true,
            description:
              "Cost estimates for materials and labor to determine a project's economic feasibility - encompassing much of what defines modern infrastructure.",
            listItems: [
              { text: 'Site design' },
              { text: 'Grading and roadway layout' },
              { text: 'Culvert design' },
              { text: 'Retaining wall layout' },
              { text: 'GIS overlay' },
              { text: 'DEP permitting' },
              { text: 'Zoning help' },
              { text: 'Specialist Engineer Statement' },
            ],
          },
          {
            bgImage: electrical,
            id: 'electrical',
            title: 'Electrical',
            hasListItems: true,
            description:
              'The assessment of the application of electricity, electronics, and electromagnetism in general, helping integrate physical technologies, hardware, and software systems.',
            listItems: [
              { text: 'Utility Network' },
              { text: 'Power Circulation' },
              { text: 'Emergency Power Facilities' },
              { text: 'Backup Systems' },
              { text: 'Lighting Design' },
              { text: 'Life Safety Systems' },
              { text: 'Building Systems Evaluations' },
              { text: 'Arc Flash & Coordination Studies' },
              { text: 'Energy Administration' },
            ],
          },
          {
            bgImage: environmentalAndGeotechnicalServices,
            id: 'environmentalAndGeotechnicalServices',
            title: 'Environmental and Geotechnical Services',
            hasListItems: true,
            description:
              'A healthy environment for the nation’s population - disposing of waste, providing safe drinking water, controlling environmental hazards, improving recycling, and decreasing soil, water, and air pollution.',
            listItems: [
              { text: 'Environment Restoration' },
              { text: 'Lead paint and asbestos research studies' },
              { text: 'Area 106 research studies' },
              { text: 'NEPA reports' },
              { text: 'Geotechnical analyses' },
              { text: 'Soil resistivity evaluation' },
              { text: 'Construction stage analysis' },
            ],
          },
          {
            bgImage: geospital,
            id: 'geospatial',
            title: 'Geospatial',
            hasListItems: true,
            description:
              'The management of global infrastructure through the collection, measuring, monitoring, and archiving of geospatial data.',
            listItems: [
              { text: 'GIS Data Design & Mapping' },
              { text: 'Servicing & Data Conversion' },
              { text: 'Data Interpretation & Examination' },
              { text: 'Spatial & 3D Analsysis' },
              { text: 'Highways / Mapping' },
            ],
          },
          {
            bgImage: industrialWaterSupply,
            id: 'industrialWaterSupply',
            title: 'Industrial Water Supply',
            hasListItems: true,
            description:
              'Application of engineering principles and techniques of scientific management to the maintenance of an optimal level of productivity at optimum cost in industrial enterprises.',
            listItems: [
              { text: 'Industrial Waste Studies' },
              { text: 'Headworks Examination & Long-term Monitoring' },
              { text: 'NPDES Permit Negotiation, Pretreatment Permit Concurrence' },
              { text: 'Regulatory Negotiations, Regulatory Conformity Planning' },
              { text: 'Sewer Use Ordinance & Enforcement Reaction Plan Improvement' },
              { text: 'Treatment System Design, Construction Oversight & Operation' },
              { text: 'In-Plant Sampling Applications & Waste Characterization Research' },
              { text: 'Comprehensive Wastewater Management Programs' },
              { text: 'Groundwater Compliance' },
              { text: 'Environmental Submission, Pollution Avoidance Audits' },
              { text: 'Industrial Staff Instruction & Corporate Concurrence Seminars' },
              { text: 'Security Training & Threat Assessment' },
            ],
          },
          {
            bgImage: mechanical,
            id: 'mechanical',
            title: 'Mechanical',
            hasListItems: true,
            description:
              'Design, manufacturing, testing, and improvement of mechanical systems, which are used in virtually any industry one can think of.',
            listItems: [
              {
                text: 'Conducting research into the feasibility, design, operation and performance of mechanisms, components and devices',
              },
              {
                text: 'Planning and managing assignments, cost and timing estimations, reports and design requirements for equipment and systems',
              },
              { text: 'Analyzing dynamics and vibrations of mechanical systems and buildings' },
              {
                text: 'Developing routine maintenance specifications, schedules and applications and provide assistance to industrial upkeep crews',
              },
              { text: 'Investigating mechanical problems or unexpected upkeep problems' },
              { text: 'Selecting supplies for product requirements when it comes to toughness, weight, cost and safety' },
              { text: 'Mining' },
            ],
          },
          {
            bgImage: oilGasPetroleum,
            id: 'oilGasPetroleum',
            title: 'Oil, Gas & Petroleum',
            hasListItems: true,
            description:
              'Production of oil and gas in an efficient, economical, and environmentally safe manner with the help of smart engineering solutions.',
            listItems: [
              { text: 'Tap/regulator station design and style' },
              { text: 'Transmission design' },
              { text: 'Distribution systems' },
              { text: 'Hydraulic modeling' },
              { text: 'Procurement' },
            ],
          },
          {
            bgImage: wastewaterSolutions,
            id: 'wastewaterSolutions',
            title: 'Wastewater Solutions',
            hasListItems: true,
            description:
              'The removal of impurities from wastewater, or sewage, before they reach aquifers or natural bodies of water such as rivers, lakes, and oceans.',
            listItems: [
              { text: 'Industrial Waste Research' },
              { text: 'Headworks Evaluation & Long-term Monitoring' },
              { text: 'NPDES Permit Mediation, Pretreatment Permit Concurrence' },
              { text: 'Regulatory Discussions, Regulating Compliance Planning' },
              { text: 'Sewer Use Regulation & Administration Reaction Plan Development' },
              { text: 'Treatment System Design, Building Oversight & Procedure' },
              { text: 'In-Plant Sampling Programs & Waste Characterization Research' },
              { text: 'Complete Wastewater Management Applications' },
              { text: 'Groundwater Conformity' },
              { text: 'Environmental Compliance, Pollution Prevention Audits' },
              { text: 'Industrial Personnel Training & Corporate Compliance Seminars' },
              { text: 'Security Training & Threat Analysis' },
            ],
          },
          {
            bgImage: transmissionEngineering,
            id: 'transmissionEngineering',
            title: 'Transmission Engineering',
            hasListItems: true,
            description:
              'Innovative engineering services to design, maintain, or upgrade power delivery systems in a cost-effective, safe, timely, and reliable manner.',
            listItems: [
              { text: 'Ranking evaluation' },
              { text: 'Path preparation' },
              { text: 'Upgrades and rebuilds' },
              { text: 'Line layout' },
              { text: 'Structure design' },
              { text: 'Structure investigation' },
              { text: 'LiDAR control' },
              { text: 'Devices specs' },
              { text: 'Procurement' },
              { text: 'Line optimization' },
              { text: 'Clearance infraction reporting' },
            ],
          },
        ]}
      />
    </>
  );
};

export default Engineering;
